<template>
  <fieldset>
    <div class="result-message similar-scheduled-ride">
      <h3 class="error">
        Warning: There is a scheduled ride # {{ scheduledRide.id }} at<br>
        <span class="scheduled-info">{{ scheduledRide.firstPickup }}</span> to
        <span class="scheduled-info">{{ scheduledRide.rideName }}</span>
      </h3>
    </div>
    <hr>
  </fieldset>
</template>

<script setup lang="ts">
defineProps({
  scheduledRide: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss">
.similar-scheduled-ride {
  &.result-message {
    white-space: normal;
    .scheduled-info {
      color: #b71f03;
    }
  }
}
</style>
